import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import Scrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getParties } from "../../../store/actions/parties";
import DebounceInput from "../../general/DebounceInput";
import LoaderSimple from "../../general/loader";
import VaporFullscreenOverlay from "../../vapor/fullscreenOverlay";
import CreateNewContactView from "../../../views/parties/createNewContactView";
import "./style.css";
import { useLocation } from "react-router-dom";

const PartiesSearchInput = props => {
  const {
    disabled,
    selected,
    onSelect,
    onClear,
    placeholder,
    width,
    registryStore,    
    label,
    customStyles,    
    getPopupContainer,
    source
  } = props;

  const location = useLocation();
  const auth = useSelector(state => state.auth);
  const main = useSelector(state => state.main);
  const parties = useSelector(state => state.parties);
  const dispatch = useDispatch();
  const [value, setValue] = useState(undefined);
  const [showTooltip, setShowTooltip] = useState(false);

  const partiesRef = useRef();

  useEffect(() => {
    if (!partiesRef.current) return undefined;
    let ps = new Scrollbar(partiesRef.current, {wheelPropagation: true});
    return () => {
      if (ps) {
        ps.destroy();
        ps = null;
      }
    };
  }, [partiesRef?.current]);

  const documentEvents = (e) => {
    /*
    if (
      [
        "ant-tooltip",
        "ant-tooltip-inner",
        "ant-input dbx-parties-searchInput-debounceInput dbx-parties-searchInput-tooltip"
      ].indexOf(e.target.className) === -1
    ) {
      setShowTooltip(false);
    }
    */
  };

  useEffect(() => {
    dispatch(getParties(
      auth, main.companyUuidSelected, 100, "asc"
    ));
    document.addEventListener("click", documentEvents);

    return () => {
      document.removeEventListener("click", documentEvents);
    };
  }, []);

  useEffect(() => {
    if (value && value !== "" && value.length > 2) {
      dispatch(getParties(
        auth, main.companyUuidSelected, 100, "asc", value
      ));
    }
    if (value === "") {
      dispatch(getParties(
        auth, main.companyUuidSelected, 100, "asc"
      ));
    }
  }, [value]);

  useEffect(() => {
    registryStore?.setFullScreenCreateNew(false);
  }, [location]);

  const onCloseFullScreenCreate = () => {
    registryStore?.setFullScreenCreateNew(false);
    registryStore?.setIbanPaymentFormError(null);
    registryStore?.setMunicipalityError(null);
    registryStore?.setCapError(null);
    registryStore?.setProvinceError(null);
    registryStore?.setEmailError(null);
    registryStore?.setPecError(null);
    registryStore?.setIbanError(null);
    registryStore?.setVatError(null);
    registryStore?.setTaxIdError(null);
  };

  const renderTooltipContent = () => {
    let items = [
      <div
        key={"renderTooltipContent"}
        className="dbx-parties-searchInput-tooltip-item primary"
        onClick={() => {
          
          registryStore?.setFullScreenCreateNew(true);
          setShowTooltip(false);
          if (window.aptrinsic) {
            window.aptrinsic("track", "digital-box:TSPAY-AGGIUNGICONTATTO");
          }
        }}
      >
        <div>Aggiungi contatto</div>{" "}
        <div>
          <FontAwesomeIcon icon={["far", "plus"]} />
        </div>
      </div>
    ];
    
    if (parties.getParties.data && parties.getParties.data.results) {
      const partiesList = [];
      const customers =  parties.getParties.data.results.filter(p => p.relationships.includes("CUSTOMER"));
      const suppliers =  parties.getParties.data.results.filter(p => p.relationships.includes("SUPPLIER"));
      
      const dataToIterate = !source ? parties.getParties.data.results : (source === "client") ? customers : suppliers;
      
      dataToIterate?.map(party => {
        return partiesList.push(<div
          className="dbx-parties-searchInput-tooltip-item"
          onClick={() => {
            setShowTooltip(false);
            onSelect(party);
          }}
        >
          <div>{party.description}</div>
        </div>);
      });
      items.push(<div ref={partiesRef} style={{overflow: "hidden", position: "relative", maxHeight: "300px" /* ,overflow: "scroll"*/ }}>
        {partiesList}
      </div>);
    }

    if (parties.getParties.status.started) {
      items.push(<div className="dbx-parties-searchInput-tooltip-item loading">
        <LoaderSimple fontSize={16} />
      </div>);
    }

    return <div className="dbx-parties-searchInput-tooltip-list">{items}</div>;
  };

  return (
    <React.Fragment>
      {registryStore?.fullScreenCreateNew && (
        <VaporFullscreenOverlay
          title="NUOVO CONTATTO"
          onClose={() => onCloseFullScreenCreate()}
          width={"95vw"}
        >
          <CreateNewContactView            
            isFullscreenOverlay
            isPage={false}
          />
        </VaporFullscreenOverlay>
      )}
      <Tooltip
        color={"rgb(0, 80, 117)"}
        onVisibleChange={val => {setShowTooltip(val);}}
        visible={showTooltip && !selected.id && !disabled}
        trigger="click"
        /** Si prega di non cancellare, se ci sono problemi contatta Gio */
        getPopupContainer={getPopupContainer}
        placement="bottom"
        title={renderTooltipContent()}
        className={"dbx-parties-searchInput-tooltip"}
        overlayClassName={`dbx-parties-searchInput-tooltip-overlay ${source && "searchInputParties-precog"}`}
        overlayStyle={{ boxShadow:"0px 2px 4px 0px rgba(21, 41, 53, 0.32)", width: width || 450, backgroundColor: "black" }}
      >
        <DebounceInput
          {...props}
          disabled={disabled}
          className={"dbx-parties-searchInput-debounceInput"}
          label={label}
          style={{ width: width || 450, ...customStyles }}
          value={selected ? selected.description : value}
          readOnly={selected && selected.id ? true : false}
          placeholder={placeholder}
          onClick={() => setShowTooltip(true)}
          onChange={val => {
            onSelect({ ...selected, description: val });
            setValue(val);
          }}
          suffix={
            selected &&
            selected.id && (
              <div
                className="dbx-parties-searchInput-clear"
                onClick={() => onClear()}
              >
                <FontAwesomeIcon icon={["far", "times-circle"]} />
              </div>
            )
          }
        />
      </Tooltip>
    </React.Fragment>
  );
};

export default PartiesSearchInput;
